import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import './ButtonList.scss';
import {isBrowser, isMobile} from 'react-device-detect';

const ButtonsList = ({links, actionCallback, containerWidth}) => {
  const determineHref = (link) => {
    return actionCallback ? '' : link;
  };

  const containerStyle = containerWidth ? {width: `${containerWidth}px`} : {width: '690px'};

  const buttons = links.map((link, index) => {
    const badgeStyle = link.badgeColor ? {backgroundColor: link.badgeColor} : {};

    return (
      <a
        key={index}
        href={determineHref(link.href)}
        onClick={actionCallback ? () => actionCallback(link) : null}
        className={`action-button ${link.isAllActionsButton ? 'all-actions-button' : ''}`}>
        <span className='button-title'>{link.title}</span>
        {link.showBadge && link.badgeTitle ? (
          <span className='button-badge' style={badgeStyle}>
            {link.badgeTitle}
          </span>
        ) : null}
        {link.isAllActionsButton && <Image className='all-actions-icon' src={require('./plus-icon.svg')} />}
      </a>
    );
  });

  return (
    <div className={isBrowser ? 'buttons-list-container' : 'buttons-list-container-mobile'} style={isBrowser ? containerStyle : undefined}>
      {buttons}
    </div>
  );
};

export default ButtonsList;

